import React, { useState } from 'react';
import { Project } from '../../types/project';
import { ProjectTable } from './ProjectTable';
import { NewProjectModal } from './NewProjectModal';

interface MyProjectsTabProps {
  projects: Project[];
}

export function MyProjectsTab({ projects }: MyProjectsTabProps) {
  const [showNewProject, setShowNewProject] = useState(false);

  return (
    <>
      <h2>
        <i className="fas fa-user" aria-hidden="true" /> My Projects
        <button className="btn btn-primary pull-right" onClick={() => setShowNewProject(true)}>
          Add a project <i className="fas fa-plus-circle" aria-hidden="true" style={{ color: '#fff' }} />
        </button>
      </h2>
      <ProjectTable projects={projects} hideRoles />
      {showNewProject && (
        <NewProjectModal onClose={() => setShowNewProject(false)} />
      )}
    </>
  );
}
